module.exports = __webpack_public_path__ + "static/media/newmainlogo.69c079d8.webp";